// Values that are identical in every environment file: the jspreadsheet licence,
// issued once for all deployment domains, the Zendesk custom-field ids, which
// belong to the Zendesk account rather than to a deployment, and the import
// templates, which ship with the app.

export const jspreadsheetLicense = {
  key: 'MWEyZmEzOTQ3ODE2YTQxZDQxMjE5ZDE0NDhmMmRiNTFiYTU5MjdkODNkYzJlMTc2OGU3Y2I5MGY3OThiYmYwOWM4NWZkYWQyYWVmOGI1NTg1NjBiMDg2MGViYjViOGQ2MDk2MTVlZjdiNGVmMWJlM2VhODNmOTIzZTgzZmIzMDMsZXlKamJHbGxiblJKWkNJNklqQTNaR0V3WTJNNVpEUXpZalE1T0RjeFl6QXhZalptWkdWaFlqazNNMkZqWVRJelpXTXlORFVpTENKdVlXMWxJam9pUW05eWFYTWdUV2xvWVhsc2IzWWlMQ0prWVhSbElqb3hPREl4TWpJeU1EQXdMQ0prYjIxaGFXNGlPbHNpYkdGMWRHVmpaSEJ5ZDJWaU1uUmxjM1F1ZWpZdWQyVmlMbU52Y21VdWQybHVaRzkzY3k1dVpYUWlMQ0prY0hJdWJHRjFkR1ZqTG1OdmJTSXNJbXhoZFhSbFkyUndjbmRsWWpKa1pXMXZMbm8yTG5kbFlpNWpiM0psTG5kcGJtUnZkM011Ym1WMElpd2laSEJ5TG5SbGMzUXViR0YxZEdWakxtTnZiU0lzSW1Sd2NpNWtaVzF2TG14aGRYUmxZeTVqYjIwaUxDSnpkR3gwWTJSd2NuZGxZblJsYzNSM1pTNTZOaTUzWldJdVkyOXlaUzUzYVc1a2IzZHpMbTVsZENJc0luTjBiSFJqWkhCeWQyVmlaR1Z0YjNkbExubzJMbmRsWWk1amIzSmxMbmRwYm1SdmQzTXVibVYwSWl3aWMzUnNkR05rY0hKM1pXSndjbTlrZDJVdWVqWXVkMlZpTG1OdmNtVXVkMmx1Wkc5M2N5NXVaWFFpTENKc2IyTmhiR2h2YzNRaVhTd2ljR3hoYmlJNk16TXNJbk5qYjNCbElqcGJJblkzSWl3aWRqZ2lMQ0oyT1NJc0luWXhNQ0lzSW5ZeE1TSXNJbll4TWlJc0luWXhNeUlzSW1admNtMTFiR0VpTENKbWIzSnRjeUlzSW5KbGJtUmxjaUlzSW5CaGNuTmxjaUlzSW1sdGNHOXlkR1Z5SWl3aWMyVmhjbU5vSWl3aVkyOXRiV1Z1ZEhNaUxDSjJZV3hwWkdGMGFXOXVjeUlzSW1Ob1lYSjBjeUpkZlE9PQ==',
};

export const zendeskFields = {
  // Custom ticket field ids (Admin → Tickets → Fields). Blank id/value =
  // skipped. Drop-down values must be the option *tag*, not the label, and
  // every field must be "Customers can edit" or the value is silently dropped.
  userEmailFieldId: '16824499290255',
  clientFieldId: '16836860495759',
  subprojectFieldId: '16836852561935',
  appFieldId: '16835044308495',
  appFieldValue: 'dpr', // this app's option tag (constant across deployments)
  appVersionFieldId: '16836856280719',
  envFieldId: '16835076094351',
};

export const importTemplateAssets = {
  importTemplate: {
    activities: 'assets/templates/dpr/import-activities-template.xlsx',
    activityGroups: 'assets/templates/dpr/import-activity-groups-template.xlsx',
    locations: 'assets/templates/dpr/import-locations-template.xlsx',
  },
  importTemplatePreview: {
    activities: 'assets/templates/dpr/import-activities-template-preview.png',
    activityGroups:
      'assets/templates/dpr/import-activity-groups-template-preview.png',
    locations: 'assets/templates/dpr/import-locations-template-preview.png',
  },
};
